module.exports = __webpack_public_path__ + "media/theme/icon__sale--sp-ebc894fc.png";